import { render, staticRenderFns } from "./CalendarOfMonth.vue?vue&type=template&id=60e463e8&scoped=true&lang=pug"
import script from "./CalendarOfMonth.vue?vue&type=script&lang=ts"
export * from "./CalendarOfMonth.vue?vue&type=script&lang=ts"
import style0 from "./CalendarOfMonth.vue?vue&type=style&index=0&id=60e463e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e463e8",
  null
  
)

export default component.exports